export default __webpack_public_path__ + "static/media/japan.928d114a.svg";